module.exports = __webpack_public_path__ + "img/addCard.c17dd9c4.png";